var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _c("h2", { staticClass: "mb-2", attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("UserManagement.AdminManagement.Title")))
    ]),
    _vm._v(" "),
    _c("div", {
      domProps: {
        innerHTML: _vm._s(_vm.$t("UserManagement.AdminManagement.Instructions"))
      }
    }),
    _vm._v(" "),
    _vm.hasNewAdminUsers
      ? _c("div", { staticClass: "table-responsive" }, [
          _c("table", { staticClass: "table tablerow users-table" }, [
            _c("thead", [
              _c("tr", [
                _c("th", { staticClass: "w-20" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("UserManagement.Name")))])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "w-30" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("UserManagement.Email")))])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "w-30" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("UserManagement.Procurator.Title")))
                  ])
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "w-20 centered" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("UserManagement.AdminManagement.Operation.Title")
                      )
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.adminUsers, function(user, index) {
                return _c("tr", [
                  _c("td", [_c("span", [_vm._v(_vm._s(user.fullName))])]),
                  _vm._v(" "),
                  _c("td", [_c("span", [_vm._v(_vm._s(user.email))])]),
                  _vm._v(" "),
                  user.hasProcuration
                    ? _c("td", [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("UserManagement.Procurator.Yes"))
                          )
                        ])
                      ])
                    : _c("td", { staticClass: "centered" }, [
                        _c("span", [_vm._v("-")])
                      ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "centered" }, [
                    _c("span", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: _vm.updating,
                            "aria-label": _vm.$t(
                              "UserManagement.AdminManagement.Operation.Approve"
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.approve(user.id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "UserManagement.AdminManagement.Operation.Approve"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: {
                            type: "button",
                            disabled: _vm.updating,
                            "aria-label": _vm.$t(
                              "UserManagement.AdminManagement.Operation.Reject"
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.reject(user.id)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "UserManagement.AdminManagement.Operation.Reject"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              }),
              0
            )
          ])
        ])
      : _c("div", [
          _c("hr", { staticClass: "mt-1" }),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("UserManagement.AdminManagement.NoAdminUsers"))
            )
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }